import React from 'react';
import FlowRendererField from '../renderers/FlowRendererField';

export default class FlowComponentDefault extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { component, path, id, ...passProps } = this.props;

        return (
            <FlowRendererField
                component={component}
                fields={component?.fields}
                path={`${path}.fields`}
                id={`${id}.fields`}
                {...passProps}
            />
        );
    }
}
